<template>
    <input 
        type="checkbox" 
        :id="id"
        :name="name"
        :value="value"
        :checked="isChecked"
        @change="handleChange"
        class="checkbox__input"
    />
</template>

<script>
export default {
    name: 'TCheckbox',
    
    props: {
        id: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        modelValue: {
            type: [Array, Boolean, String, Number],
            default: false
        }
    },
    
    emits: ['update:modelValue', 'change'],
    
    computed: {
        isChecked() {
            if (Array.isArray(this.modelValue)) {
                return this.modelValue.includes(this.value);
            }
            if (this.value !== null && this.value !== undefined) {
                return this.modelValue === this.value;
            }
            return Boolean(this.modelValue);
        }
    },
    
    methods: {
        handleChange(event) {
            const checked = event.target.checked;
            
            if (Array.isArray(this.modelValue)) {
                const newValue = [...this.modelValue];
                if (checked) {
                    if (!newValue.includes(this.value)) {
                        newValue.push(this.value);
                    }
                } else {
                    const index = newValue.indexOf(this.value);
                    if (index > -1) {
                        newValue.splice(index, 1);
                    }
                }
                this.$emit('update:modelValue', newValue);
            } else if (this.value !== null && this.value !== undefined) {
                this.$emit('update:modelValue', checked ? this.value : null);
            } else {
                this.$emit('update:modelValue', checked);
            }
            
            this.$emit('change', event);
        }
    }
}
</script>
